import { useEffect } from "react";
import { useDispatch } from "react-redux";

import { ResignationState } from "@reducers/types/HRM/resignation-state";

import {
  createResignationRequest,
  getResignationRequest,
} from "@actions/HRM/resignation/resignation-actions";
import { getResignationState } from "@selectors/HRM/resignation/resignation-selector";

import { useAppSelector } from "@helpers/redux";
import { ResignationType } from "@type/HRM/resignation";

interface UseResignation {
  resignation: ResignationType;

  getResignationRequestOngoing: boolean;
  getResignationSuccess: boolean;
  getResignationFailed: boolean;

  createResignationRequestOngoing: boolean;
  createResignationSuccess: boolean;
  createResignationFailed: boolean;

  createResignation: (event: ResignationType) => void;
}

export const useResignation = (employeeId?: number): UseResignation => {
  const dispatch = useDispatch();

  const {
    data,
    getResignationRequestOngoing,
    getResignationSuccess,
    getResignationFailed,
    createResignationRequestOngoing,
    createResignationSuccess,
    createResignationFailed,
  } = useAppSelector<ResignationState>(getResignationState);

  useEffect(() => {
    if (employeeId) dispatch(getResignationRequest(employeeId));
  }, [dispatch]);

  const resignation = data as ResignationType;

  const createResignation = (data: ResignationType) => {
    dispatch(createResignationRequest(data));
  };

  return {
    resignation,

    getResignationRequestOngoing,
    getResignationSuccess,
    getResignationFailed,

    createResignationRequestOngoing,
    createResignationSuccess,
    createResignationFailed,

    createResignation,
  };
};
